import { Flex as AntFlex } from "antd";
import type { FlexProps as AntFlexProps } from "antd";

export interface FlexProps extends AntFlexProps {
  children?: React.ReactNode;
}

export function Flex({ children, ...props }: FlexProps) {
  return <AntFlex {...props}>{children}</AntFlex>;
}
